export default __webpack_public_path__ + "static/media/jana waterfall1.ef12cb2a.jpg";